import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, Smartphone, Wrench, Package, ShoppingCart, Settings, BarChart3, MessageSquare, LogOut, ChevronLeft, ChevronRight, UserCog, Cog, Plug, Calculator, Printer } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
const Sidebar = ({ isOpen, onToggle }) => {
    const { user, logout, hasPermission } = useAuth();
    const location = useLocation();
    const navigationItems = [
        {
            name: 'Dashboard',
            href: '/dashboard',
            icon: LayoutDashboard,
            roles: ['ADMIN', 'TECNICO', 'VENDEDOR']
        },
        {
            name: 'Clientes',
            href: '/clientes',
            icon: Users,
            roles: ['ADMIN', 'TECNICO', 'VENDEDOR']
        },
        {
            name: 'Equipamentos',
            href: '/equipamentos',
            icon: Smartphone,
            roles: ['ADMIN', 'TECNICO', 'VENDEDOR']
        },
        {
            name: 'Ordens de Serviço',
            href: '/ordens-servico',
            icon: Wrench,
            roles: ['ADMIN', 'TECNICO']
        },
        {
            name: 'Orçamentos',
            href: '/orcamentos',
            icon: Calculator,
            roles: ['ADMIN', 'TECNICO', 'VENDEDOR']
        },
        {
            name: 'Cupons Térmicos',
            href: '/cupons-termicos',
            icon: Printer,
            roles: ['ADMIN']
        },
        {
            name: 'Stock',
            href: '/estoque',
            icon: Package,
            roles: ['ADMIN', 'TECNICO', 'VENDEDOR']
        },
        {
            name: 'Serviços',
            href: '/servicos',
            icon: Cog,
            roles: ['ADMIN', 'TECNICO']
        },
        {
            name: 'Vendas',
            href: '/vendas',
            icon: ShoppingCart,
            roles: ['ADMIN', 'VENDEDOR']
        },
        {
            name: 'Relatórios',
            href: '/relatorios',
            icon: BarChart3,
            roles: ['ADMIN']
        },
        {
            name: 'Notificações',
            href: '/notificacoes',
            icon: MessageSquare,
            roles: ['ADMIN', 'TECNICO']
        },
        {
            name: 'Integrações',
            href: '/integracoes',
            icon: Plug,
            roles: ['ADMIN'],
            subItems: [
                {
                    name: 'WhatsApp',
                    href: '/integracoes/whatsapp',
                    roles: ['ADMIN']
                },
                {
                    name: 'Email',
                    href: '/integracoes/email',
                    roles: ['ADMIN']
                }
            ]
        },
        {
            name: 'Utilizadores',
            href: '/usuarios',
            icon: UserCog,
            roles: ['ADMIN']
        },
        {
            name: 'Configurações',
            href: '/configuracoes',
            icon: Settings,
            roles: ['ADMIN'],
            subItems: [
                {
                    name: 'Estados OS',
                    href: '/configuracoes/estados-os',
                    roles: ['ADMIN']
                }
            ]
        }
    ];
    const filteredNavigation = navigationItems.filter(item => hasPermission(item.roles));
    const handleLogout = async () => {
        try {
            await logout();
        }
        catch (error) {
            console.error('Erro ao fazer logout:', error);
        }
    };
    return (_jsxs(_Fragment, { children: [isOpen && (_jsx("div", { className: "fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden", onClick: onToggle })), _jsxs("div", { className: `
          fixed top-0 left-0 z-50 h-full bg-white border-r border-gray-200 transition-all duration-300 ease-in-out
          ${isOpen ? 'w-64' : 'w-16'}
          lg:relative lg:translate-x-0
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `, children: [_jsxs("div", { className: "flex items-center justify-between h-16 px-4 border-b border-gray-200", children: [isOpen && (_jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("div", { className: "w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center", children: _jsx(Wrench, { className: "w-5 h-5 text-white" }) }), _jsx("span", { className: "font-bold text-gray-900", children: "NexaMakers" })] })), _jsx("button", { onClick: onToggle, className: "p-1 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500", children: isOpen ? (_jsx(ChevronLeft, { className: "w-5 h-5 text-gray-600" })) : (_jsx(ChevronRight, { className: "w-5 h-5 text-gray-600" })) })] }), _jsx("nav", { className: "flex-1 px-2 py-4 space-y-1 overflow-y-auto", children: filteredNavigation.map((item) => {
                            const isActive = location.pathname.startsWith(item.href);
                            return (_jsxs(NavLink, { to: item.href, onClick: () => {
                                    // Fechar sidebar automaticamente em mobile quando um item é clicado
                                    if (window.innerWidth < 1024) { // lg breakpoint
                                        onToggle();
                                    }
                                }, className: `
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors
                  ${isActive
                                    ? 'bg-primary-100 text-primary-700'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}
                `, title: !isOpen ? item.name : undefined, children: [_jsx(item.icon, { className: `
                    flex-shrink-0 w-5 h-5
                    ${isActive ? 'text-primary-500' : 'text-gray-400 group-hover:text-gray-500'}
                    ${isOpen ? 'mr-3' : 'mx-auto'}
                  ` }), isOpen && (_jsx("span", { className: "truncate", children: item.name }))] }, item.name));
                        }) }), _jsxs("div", { className: "border-t border-gray-200 p-4", children: [isOpen && user && (_jsx("div", { className: "mb-3", children: _jsxs("div", { className: "flex items-center space-x-3", children: [_jsx("div", { className: "w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center", children: _jsx("span", { className: "text-sm font-medium text-gray-700", children: user.nome.charAt(0).toUpperCase() }) }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("p", { className: "text-sm font-medium text-gray-900 truncate", children: user.nome }), _jsx("p", { className: "text-xs text-gray-500 truncate", children: user.tipo.charAt(0) + user.tipo.slice(1).toLowerCase() })] })] }) })), _jsxs("button", { onClick: handleLogout, className: `
              group flex items-center w-full px-2 py-2 text-sm font-medium text-gray-600 rounded-md
              hover:bg-gray-50 hover:text-gray-900 transition-colors
            `, title: !isOpen ? 'Sair' : undefined, children: [_jsx(LogOut, { className: `
                flex-shrink-0 w-5 h-5 text-gray-400 group-hover:text-gray-500
                ${isOpen ? 'mr-3' : 'mx-auto'}
              ` }), isOpen && _jsx("span", { children: "Sair" })] })] })] })] }));
};
export default Sidebar;
